// Environment detection utility function
function getEnvironmentValue<T>(
  envValues: Record<string, T>,
  defaultValue: T
): T {
  // 使用 Vite 的 define 配置注入的 API_ENV
  const nodeEnv = process.env.NODE_ENV || 'production';
  return envValues[nodeEnv] || defaultValue;
}

// 分销服务侧接口地址
const DISTRIBUTION_URL = getEnvironmentValue(
  {
    development: '',
    test: '',
    production: '',
  },
  ''
)

export {
  getEnvironmentValue,
  DISTRIBUTION_URL,
}